import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');
    const adminToken = sessionStorage.getItem('admin_token');

    const finalToken = adminToken ? adminToken : token;
    if (finalToken) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${finalToken}`,
        },
      });
      return next.handle(authReq);
    }

    return next.handle(req);
  }
}
